import { call, put, takeLatest, select } from 'redux-saga/effects'
import { setAuthentication } from 'shared/helpers/authentication'
import bootRollbar from 'shared/helpers/rollbar'
import { storage } from 'shared/helpers/user'
import { set } from 'js-cookie'
import * as types from 'store/user/userTypes'
import API from 'store/user/userApis'
import Storage from 'shared/helpers/storage'
import { isProjectManager } from 'shared/helpers/user'
import { fillUserTimezone,parseJwt } from 'shared/helpers/functional'
import { isPMOrAdmin  } from 'shared/helpers/user'
import {
  path,
} from 'ramda'

const delay = (ms) => new Promise(res => setTimeout(res, ms))


export function* fetchUser({ payload }) {
  try {

    let response
    const loginRoles = yield select(path(['login', 'roles']))
    if (payload){
      response = yield call(API.getUserInfoRequest, payload.moderatorId)
    }
    else {
      const tokenDecoded = parseJwt(Storage.getItem('accessToken'))
      response = yield call(API.getCognitoUserInfoRequest, tokenDecoded['custom:userId'])
      Storage.setItem('firstName', response.data.last_name)
      Storage.setItem('lastName', response.data.first_name)
    }
    if (response.status === 200) {
      if (payload) {
        yield put({ type: 'FETCH_BUFFER_SUCCEEDED', payload: response.data })
      } else {
        yield put({ type: 'FETCH_USER_SUCCEEDED', payload: response.data })
        const defaultTimeZone = fillUserTimezone(response.data.time_zone, isProjectManager())
        yield put({ type: 'SET_SCHEDULER_TIMEZONE', payload: defaultTimeZone.timeZone })
        yield put({ type: 'FETCH_BUFFER_SUCCEEDED', payload: response.data })
        
        if(response.data.accountsSelected){
          yield put({type: "SELECT_ACCOUNT", payload: {account: response.data.accountsSelected, hideTooltip: true }})
          yield put({type: "SELECT_CLIENT", payload: {clients: response.data.clientsSelected.length? new Set(response.data.clientsSelected) : new Set(), fromLogin: true }});
          yield put({type: "SET_ACCOUNTS_SELECTED", payload: {accountsSelected: true, clientsSelected: true}})
          if(isPMOrAdmin() || (loginRoles.includes('QUAL_SCHEDULER_MANAGER')) ||  (loginRoles.includes('QUAL_SCHEDULER_ADMIN'))) yield put({type: "UPDATE_ACCOUNT_SELECTION", payload: response.data.accountsSelected})
        } 
        else {
          if(isPMOrAdmin() || (loginRoles.includes('QUAL_SCHEDULER_MANAGER')) ||  (loginRoles.includes('QUAL_SCHEDULER_ADMIN'))) yield put({type: "SET_ACCOUNTS_SELECTED", payload: {accountsSelected: true, clientsSelected: false}})
        }
    }
  }
  } catch (error) {
    storage.clear()
    console.log("error ", error)
    yield put({ type: 'FETCH_USER_FAILED' })
  }
}

function* fetchUserForComms ({ payload: { conferenceHash, userHash } }) {
  try {
    const data = yield call(API.loginUserFromComms, conferenceHash, userHash)
    storage.clear()
    yield call(setAuthentication, data)
    bootRollbar({id: data.id, email: data.email})
    yield set('ic-participant', userHash)
    yield put({ type: 'FETCH_USER_SUCCEEDED' })
  } catch (error) {
    storage.clear()
    yield put({ type: 'FETCH_USER_FAILED' })
  }
}


function* watchUpdateUserTimezone({payload}) {
  try {
    const response = yield call(API.updateUserTimezone,payload)
   if ( response.status === 200 ) {
      yield put({type:'UPDATE_USER_TIMEZONE_SUCCEEDED',  timezone: payload.timezone});
      yield put({type:'CLOSE_CHANGE_TIMEZONE_MODAL'});
      yield put({type:'SET_SCHEDULER_TIMEZONE',  payload: payload.timezone});
      yield put({type: 'SHOW_MESSAGE', payload: {message: 'Changes have been saved.', className: 'copy-screeners-snackbar'}})
      yield put({type: 'HIDE_MESSAGE'})
    } else {
        yield put({type: 'UPDATE_USER_TIMEZONE_FAILED'})
        yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again',className: 'copy-screeners-snackbar'}})
        yield put({type: 'HIDE_MESSAGE'})
    }
   } catch (err) {
       console.log("update user timezone request failed: ",err);
       yield put({type:'UPDATE_USER_TIMEZONE_FAILED', err})
       yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again', className: 'copy-screeners-snackbar'}})
       yield put({type: 'HIDE_MESSAGE'})
     }
}


function* watchMatchCurrentPassword({payload}) {
  try {
    const tokenDecoded = parseJwt(Storage.getItem('accessToken'))
    const userId =  tokenDecoded['custom:userId']
    const response = yield call(API.matchCurrentPassword, {password: payload.currentPassword, userId})
   if ( response.status === 200 && response.data.body.passwordMatches ) {
      yield put({type:'PUT_PASSWORD_MATCHES_SUCCEEDED'});
      yield put({type:'PUT_USER_PASSWORD_REQUESTED',  payload :{password : payload.password,  userId :userId}});
    } else {
        yield put({type: 'PUT_PASSWORD_MATCHES_FAILED'})
    }
   } catch (err) {
       console.log("match user password request failed: ",err);
       yield put({type: 'PUT_PASSWORD_MATCHES_FAILED', err})
       yield put({type: 'SHOW_MESSAGE', payload: {message: 'The current password you provided does not match the one we have on records.', className: 'copy-screeners-snackbar'}})
       yield put({type: 'HIDE_MESSAGE'})
     }
}



function* watchPutUserPasword({payload}) {
  try {
    const response = yield call(API.putUserPasword,payload)
   if ( response.status === 200 && !response.data.body.error) {
      yield put({type: 'PUT_USER_PASSWORD_SUCCEEDED'});
      yield put({type: 'CLOSE_CHANGE_PASSWORD_MODAL'});
      yield put({type: 'SHOW_MESSAGE', payload: {message: 'Changes have been saved.', className: 'copy-screeners-snackbar'}})
      yield put({type: 'HIDE_MESSAGE'})
      yield delay(1500);
      yield put({type: 'LOGOUT'})
    } else {
        yield put({type: 'PUT_USER_PASSWORD_FAILED'})
        yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again',className: 'copy-screeners-snackbar'}})
        yield put({type: 'HIDE_MESSAGE'})
    }
   } catch (err) {
       console.log("match user password request failed: ",err);
       yield put({type: 'PUT_USER_PASSWORD_FAILED', err})
       yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again', className: 'copy-screeners-snackbar'}})
       yield put({type: 'HIDE_MESSAGE'})
     }
}


function* watchFetchAllUsersDetails() {
  try {
    const response = yield call(API.fetchAllUsersDetails)
   if ( response.status === 200 ) {
      yield put({type: 'FETCH_ALL_USERS_DETAILS_SUCCEEDED', usersDetails : response.data});
    } else {
        yield put({type: 'FETCH_ALL_USERS_DETAILS_FAILED'})
        yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again',className: 'copy-screeners-snackbar'}})
        yield put({type: 'HIDE_MESSAGE'})
    }
   } catch (err) {
       console.log("fetch all users details request failed: ",err);
       yield put({type: 'FETCH_ALL_USERS_DETAILS_FAILED', err})
       yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again', className: 'copy-screeners-snackbar'}})
       yield put({type: 'HIDE_MESSAGE'})
     }
}

function* watchUpdateAllowContactByEmail({payload}) {
  try {
    const response = yield call(API.updateAllowContactByEmail, payload)
   if ( response.status === 200 ) {
      yield put({type: 'UPDATE_ALLOW_CONTACT_BY_EMAIL_SUCCEEDED', payload :payload, date: response.data[3].records[0].modified_date});
      yield put({type: 'CLOSE_CONTACT_PREFERENCES_MODAL'});
      yield put({type: 'SHOW_MESSAGE', payload: {message: `Qual Scheduler User "${payload.name}" has been updated.`,className: 'copy-screeners-snackbar'}})
      yield put({type: 'HIDE_MESSAGE'})
    } else {
        yield put({type: 'UPDATE_ALLOW_CONTACT_BY_EMAIL_FAILED'})
        yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again',className: 'copy-screeners-snackbar'}})
        yield put({type: 'HIDE_MESSAGE'})
    }
   } catch (err) {
       console.log("update contact preferences request failed: ",err);
       yield put({type: 'UPDATE_ALLOW_CONTACT_BY_EMAIL_FAILED', err})
       yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again', className: 'copy-screeners-snackbar'}})
       yield put({type: 'HIDE_MESSAGE'})
     }
}


export default function* watchFetchUser () {
  yield takeLatest(types.FETCH_USER_REQUESTED, fetchUser)
  yield takeLatest(types.FETCH_USER_FOR_COMMS_REQUESTED, fetchUserForComms)
  yield takeLatest(types.PUT_USER_PASSWORD_REQUESTED, watchPutUserPasword)
  yield takeLatest(types.UPDATE_USER_TIMEZONE_REQUESTED, watchUpdateUserTimezone)
  yield takeLatest(types.PUT_PASSWORD_MATCHES_REQUESTED, watchMatchCurrentPassword)
  yield takeLatest(types.FETCH_ALL_USERS_DETAILS_REQUESTED, watchFetchAllUsersDetails)
  yield takeLatest(types.UPDATE_ALLOW_CONTACT_BY_EMAIL_REQUESTED, watchUpdateAllowContactByEmail)
}
